<template>
  <roe-error-message :field="design.employer_match_number_tiers">
    <v-select
      name="employer_match_number_tiers"
      v-model="design.$model.employer_match_number_tiers"
      :options="tierOptions"
      :reduce="label => label.code"
      required
      @input="changeTiersNumber"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerMatchNumberTiersSelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  computed: {
    tierOptions() {
      let options = [
        { code: 1, label: 1 },
        { code: 2, label: 2 },
        { code: 3, label: 3 },
        { code: 4, label: 4 },
        { code: 5, label: 5 },
        { code: 6, label: 6 },
        { code: 7, label: 7 },
        { code: 8, label: 8 },
        { code: 9, label: 9 },
        { code: 10, label: 10 }
      ];
      if (this.design.$model.employer_match_yos_vary_ee === "yes")
        options.shift();
      return options;
    }
  },
  methods: {
    changeTiersNumber() {
      let tiersNumber = this.design.$model.employer_match_number_tiers;
      while (tiersNumber > this.design.$model.tiers.length)
        this.design.$model.tiers.push({});
      while (tiersNumber < this.design.$model.tiers.length)
        this.design.$model.tiers.pop();
    }
  }
};
</script>
